import loadable from '@loadable/component';

const RoleListPage = loadable(() => import('./page'));
const RoleDetailPage = loadable(() => import('./[id]/page'));
const NewRoleDialog = loadable(() => import('./new-role.dialog'));
const EditRoleDialog = loadable(() => import('./edit-role.dialog'));

export const routes = [
  {
    path: '',
    element: <RoleListPage />,
    children: [
      {
        path: 'new',
        element: <NewRoleDialog />,
      },
      {
        path: 'edit/:id',
        element: <EditRoleDialog />,
      },
    ],
  },

  {
    path: ':id',
    element: <RoleDetailPage />,
    children: [
      {
        path: 'edit',
        element: <EditRoleDialog />,
      },
    ],
  },
];
